import { AbstractControl, ValidationErrors } from '@angular/forms';

export function generateDateRange(
  startDate: string | Date,
  endDate: string | Date,
): string[] {
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (start > end) {
    throw new Error('Das Startdatum muss vor dem Enddatum liegen.');
  }

  const dateArray: string[] = [];
  const currentDate = new Date(start);

  while (currentDate <= end) {
    dateArray.push(currentDate.toISOString().split('T')[0]); // YYYY-MM-DD Format
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dateArray;
}

export function getCurrentMysqlTimestamp(): string {
  const now = new Date();

  const pad = (n: number): string => String(n).padStart(2, '0');

  return (
    `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ` +
    `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
  );
}

export function pastDateValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  const date = new Date(value);
  const now = new Date();

  return date < now ? null : { dateInFuture: true };
}
